
import { Component } from 'vue-property-decorator';
import { InputType } from '@/enums/InputType';
import VFormBuilder from '@/components/shared/form/VFormBuilder.vue';
import StackedForm from '@/mixins/StackedForm';
import { mixins } from 'vue-class-component';

@Component({
  components: { VFormBuilder },
})
export default class VoucherifyForm extends mixins(StackedForm) {
  public $refs!: {
    form: InstanceType<typeof VFormBuilder> & { form: any };
  };

  get initVals() {
    return (this.initialValues as any) || {};
  }

  get items() {
    return [
      {
        name: 'enabled',
        type: InputType.Checkbox,
        default: false,
        label: 'venue.form.voucherify.enabled',
      },
      {
        name: 'appId',
        type: InputType.Text,
        label: 'venue.form.voucherify.appId',
        autocomplete: 'off',
      },
      { name: 'appKey', type: InputType.Text, label: 'venue.form.voucherify.appKey', autocomplete: 'off' },
      {
        name: 'loyaltyCampaign',
        type: InputType.Text,
        label: 'venue.form.voucherify.loyaltyCampaign',
        rules: 'loyalty_campaign',
        autocomplete: 'off',
      },
    ];
  }

  public getData() {
    return {
      voucherify: { ...this.$refs.form.form },
    };
  }
}
